











export default

	props:
		section: Object
		current: String

	computed:
		isCurrent: -> @current == @section.id
		classes: -> [
			'active' if @isCurrent
		]

	methods:
		scrollToSection: -> @$emit('go', @section.id)

